import React, { useState } from "react";
import AuxilaryBoilersLog from "./auxilary-boilers";
import AuxilaryPurfierLog from "./auxilary-purfier";
import AuxilaryPumpLog from "./auxilary-pump";
import AuxilaryCompressorLog from "./auxilary-compressor";
import AuxilaryMachinaryLog from "./auxilary-machinary";
import AuxiRemarks from "./AuxiRemarks";

function SubMachinaryTab({ id }) {
  const [activeTab, setActiveTab] = useState("auxiliary Boilers");

  const handleClick = (name) => {
    setActiveTab(name);
    localStorage.setItem("engineLogbook", name);
  };

  return (
    <>
      <div className="white-containers">
        <ul className="sub-marine-tabs">
          <li
            className={activeTab === "auxiliary Boilers" ? "active" : ""}
            onClick={() => handleClick("auxiliary Boilers")}
          >
            Boiler
          </li>
          <li
            className={activeTab === "auxiliary Purfier" ? "active" : ""}
            onClick={() => handleClick("auxiliary Purfier")}
          >
            Purifier
          </li>

          <li
            className={activeTab === "auxiliary Pump" ? "active" : ""}
            onClick={() => handleClick("auxiliary Pump")}
          >
            Pump
          </li>
          <li
            className={activeTab === "auxiliary Compressor" ? "active" : ""}
            onClick={() => handleClick("auxiliary Compressor")}
          >
            Air Compressor
          </li>
          <li
            className={activeTab === "OtherauxiliaryMachinary" ? "active" : ""}
            onClick={() => handleClick("OtherauxiliaryMachinary")}
          >
            Other Machinary
          </li>
          <li
            className={activeTab === "AuxiRemarks" ? "active" : ""}
            onClick={() => handleClick("AuxiRemarks")}
          >
            Remarks
          </li>
        </ul>
      </div>
      <div className="white-container-contant">
        {activeTab == "auxiliary Boilers" && <AuxilaryBoilersLog id={id} />}
        {activeTab == "auxiliary Purfier" && <AuxilaryPurfierLog id={id} />}
        {activeTab == "auxiliary Pump" && <AuxilaryPumpLog id={id} />}
        {activeTab == "auxiliary Compressor" && <AuxilaryCompressorLog id={id} />}
        {activeTab == "OtherauxiliaryMachinary" && <AuxilaryMachinaryLog id={id} />}
        {activeTab == "AuxiRemarks" && <AuxiRemarks id={id} />}
      </div>
    </>
  );
}

export default SubMachinaryTab;
